module.exports = "/images/circle-marker-green.png?0b0b60bfe9d3268de2e802d48f6ac268";